// extracted by mini-css-extract-plugin
module.exports = {"fullMapTriggerButton":"FullMapButton_fullMapTriggerButton__r-FXm","icon":"FullMapButton_icon__3fnH1"};